import config from "@/config";

let cachedPublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "";
let resolvePromise = null;

export function getCachedStripePublishableKey() {
  return cachedPublishableKey || null;
}

export async function resolveStripePublishableKey() {
  if (cachedPublishableKey) {
    return cachedPublishableKey;
  }

  if (resolvePromise) {
    return resolvePromise;
  }

  const baseUrl = config?.apis?.api?.url;
  if (!baseUrl) {
    return null;
  }

  const url = `${baseUrl}/payment/stripe/public-key/`;
  resolvePromise = fetch(url, { credentials: "omit" })
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(`Failed to load Stripe publishable key (status ${response.status})`);
      }
      const data = await response.json();
      const key = data?.publishable_key || data?.public_key || "";
      cachedPublishableKey = key || "";
      stripeConfig.publishableKey = cachedPublishableKey;
      return cachedPublishableKey || null;
    })
    .catch((error) => {
      console.warn("[StripeConfig] Unable to resolve publishable key", error);
      resolvePromise = null;
      return null;
    });

  return resolvePromise;
}

const stripeConfig = {
  publishableKey: getCachedStripePublishableKey(),
};

export default stripeConfig;
